<template>
  <div class="index">

    <div class="bigbgi">
      <div class="midbgi">
      </div>
    </div>

    <div class="fourliebiao">
      <!-- 倒计时部分 -->
      <div class="shuju">
        <!-- 左侧数据 -->
        <div class="changguan">
          <div class="time">
            <el-row :gutter="10">
              <el-col :span="6">
                <img style="width:100%;max-width:100%;height:auto;object-fit:contain" src="../assets/home/xianzuo.png" alt="">
              </el-col>
              <el-col style="text-align: center;" :span="11">
                <el-row>
                  <el-col :span="3">
                    <img src="../assets/home/yezizuo.png" alt="">
                  </el-col>
                  <el-col :span="18">
                    <div style=" font-family: SourceHanSansSC-Bold;font-size: 30px;color: #000000;letter-spacing: 0.3px;line-height: 28px;font-weight: 700">2 - 4 June 2026</div>
                  </el-col>
                  <el-col :span="3">
                    <img src="../assets/home/yeziyou.png" alt="">
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="6">
                <img style="width:100%" src="../assets/home/xianyou.png" alt="">
              </el-col>
            </el-row>
            <div style="opacity: 0.6;font-family: SourceHanSansSC-Bold;font-size: 26px;color: #000000;letter-spacing: 0.26px;line-height: 28px;font-weight: 700;text-align: center;margin:30px 0 15px 0">
              China International Exhibition Center, Beijing (Chaoyang )
            </div>
          </div>
          <div class="zgdetail">
            <el-row style="height:250px" :gutter="40">
              <el-col :span="6">
                <div class="borderstyle">
                  <div>
                    <div style=" font-family: SourceHanSansSC-Bold;font-size: 44px;letter-spacing: 0.44px;text-shadow: 0 2px 1px rgba(0, 0, 0, 0.21);font-weight: 700;color: #2361B4;">
                      {{zxzs}}
                    </div>
                    <div class="wzintro">
                     Selected Exhibitors
                    </div>
                  </div>

                </div>
              </el-col>
              <el-col :span="6">
                <div class="borderstyle">
                  <div>
                    <div style="font-family: SourceHanSansSC-Bold;font-size: 44px;letter-spacing: 0.44px;text-shadow: 0 2px 1px rgba(0, 0, 0, 0.21);font-weight: 700;color: #218A35;">
                      {{tygz}}
                    </div>
                    <div class="wzintro">
                     professional Visitor
                    </div>
                  </div>

                </div>
              </el-col>
              <el-col :span="6">
                <div class="borderstyle">
                  <div>
                    <div style="padding-top:25px;font-family: SourceHanSansSC-Bold;font-size: 42px;letter-spacing: 0.44px;text-shadow: 0 2px 1px rgba(0, 0, 0, 0.21);font-weight: 700;color: #ED3D00;">
                      {{zgmj}}m²
                    </div>
                    <div class="wzintro">
                     <!-- - Halls<br /> -->
                     30000㎡
                    </div>
                  </div>

                </div>
              </el-col>
              <el-col :span="6">
                <div class="borderstyle">
                  <div>
                    <div style="padding-top:25px;font-family: SourceHanSansSC-Bold;font-size: 44px;letter-spacing: 0.44px;text-shadow: 0 2px 1px rgba(0, 0, 0, 0.21);font-weight: 700;color: #F19F09;">
                      {{ls}}
                    </div>
                    <div class="wzintro">
                     40 years of history<br />
                    Since 1986
                    </div>
                  </div>

                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <!-- 右侧倒计时 -->
        <div class="djs">
          <div style=" margin-left: 40px;">
            <div class="textcolor ignore" style="  font-family: PingFangSC-Semibold;font-size: 50px;font-weight:600">展会倒计时</div>
            <div class="textcolor" style="font-size: 64px;font-family: LetsgoDigitalRegular">{{ countdowntime}}
              <span class="ignore" style="font-size: 60px;">天</span>
            </div>
            <div class="textcolor ignore" style="font-size: 56px;font-family: LetsgoDigitalRegular">{{sfmtime}}</div>
          </div>
        </div>
      </div>
      <!-- 功能模块 -->
      <div class="gnbox">
        <!-- 参观预约登记 -->
        <div style="display:flex">
          <!-- 黑点样式 -->
          <div style="text-align: center;margin-top:50px;">
            <div style="background: #000000;width:10px;height:10px;  border-radius: 20px;"></div>
            <div style="background: #eee;width:2px;height:120px; margin-left:4px">
            </div>
          </div>
          <!-- 内容 -->
          <a target="_blank" href="https://data.ciec.com.cn/c2l0ZTo1OTI5Mzk/p/v/register">
            <div style="margin-left:10px">
              <img src="../assets/home/canguanico.png" alt="">
              <div style=" display: flex;justify-content: space-between; align-items: center;margin:7px 0 25px 0">
                <a target="_blank" href="https://data.ciec.com.cn/c2l0ZTo1OTI5Mzk/p/v/register">
                  <div style="font-family:SourceHanSansSC-Medium;font-size: 24px;color: #000000;letter-spacing: 0;font-weight: 500;">
                    visitor registration
                  </div>
                </a>
              </div>
            </div>
          </a>

        </div>
        <!-- 线上平台 -->
        <div style="display:flex;margin-top:40px">
          <!-- 黑点样式 -->
          <div style="text-align: center;margin-top:50px;">
            <div style="background: #000000;width:10px;height:10px;  border-radius: 20px;"></div>
            <div style="background: #eee;width:2px;height:120px; margin-left:4px">
            </div>
          </div>
          <!-- 内容 -->
          <div @click="showMaintainAlert">
            <div style="margin-left:10px">
              <img src="../assets/home/xianshangico.png" alt="">
              <div style=" display: flex;justify-content: space-between; align-items: center;margin:7px 0 25px 0">
                <div>
                  <div style="font-family:SourceHanSansSC-Medium;font-size: 24px;color: #000000;letter-spacing: 0;font-weight: 500;">
                    EXHIBITOR DIRECTORY
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>
        <!-- 展馆平面图 -->
        <div style="display:flex; cursor: pointer">
          <!-- 黑点样式 -->
          <div style="text-align: center;margin-top:50px;">
            <div style="background: #000000;width:10px;height:10px;  border-radius: 20px;"></div>
            <div style="background: #eee;width:2px;height:120px; margin-left:4px">
            </div>
          </div>
          <!-- 内容 -->
          <div @click="zgpmt('2','5','展馆导览')" style="margin-left:10px">
            <img src="../assets/home/zhanguanpingmianico.png" alt="">
            <div style=" display: flex;justify-content: space-between; align-items: center;margin:7px 0 25px 0">
              <div style="font-family:SourceHanSansSC-Medium;font-size: 24px;color: #000000;letter-spacing: 0;font-weight: 500; cursor: pointer;">
               Floor plan
              </div>
            </div>
          </div>
        </div>

      </div>
      <!-- 精彩回顾 -->
      <!-- <div class="jchg">
        <div style="font-size: 50px;color: #1E293B;letter-spacing: -0.5px;line-height: 68px;font-weight: 700;margin-bottom:40px">
          往届精彩回顾
        </div>
        <div style="display: flex; justify-content: space-between;cursor: pointer">
          <div @click="zgpmt('8','2','')" class="banner">
            <el-carousel trigger="click" height="525px">
              <el-carousel-item>
                <img style="height:525px;width:100%" src="../assets/home/图2.jpg" alt="">
              </el-carousel-item>
              <el-carousel-item>
                <img style="height:525px;width:100%" src="../assets/home/图1.jpg" alt="">
              </el-carousel-item>
            </el-carousel>
            <div style="font-size: 24px;color: #1E293B;letter-spacing: 0;line-height: 33.6px;font-weight: 700;margin:15px 0">{{banneryear}}</div>
          </div>
          <div class="newslist">
            <div @click="zgpmt('8','3','')" style="display:flex;align-items: center;margin-bottom:50px">
              <img style="width:310px;height:170px;margin-right:20px" src="../assets/home/图1.jpg" alt="">
              <div>

                <div style="font-size: 24px;color: #1E293B;letter-spacing: 0;line-height: 33.6px;font-weight: 700;">第19届（2020年）</div>
              </div>
            </div>
            <div @click="zgpmt('8','4','')" style="display:flex;align-items: center;margin-bottom:50px">
              <img style="width:310px;height:170px;margin-right:20px" src="../assets/home/图3.jpg" alt="">
              <div>

                <div style="font-size: 24px;color: #1E293B;letter-spacing: 0;line-height: 33.6px;font-weight: 700;">第18届（2019年）</div>
              </div>
            </div>
            <div @click="zgpmt('8','5','')" style="display:flex;align-items: center;">
              <img style="width:310px;height:170px;margin-right:20px" src="../assets/home/图4.jpg" alt="">
              <div>

                <div style="font-size: 24px;color: #1E293B;letter-spacing: 0;line-height: 33.6px;font-weight: 700;">第17届（2018年）</div>
              </div>
            </div>
          </div>
        </div>

      </div> -->
    </div>
    <!-- <div class="zbdw"> -->
      <!-- <div :class="[zbdw==1 ? 'activeClass' : 'ycactiveClass']" @click="zbdwclick(1)">organizer</div> -->
      <!-- <div style="color:#129c7a">|</div> -->
      <!-- <div :class="[zbdw==2 ? 'activeClass' : 'ycactiveClass']" @click="zbdwclick(2)">支持单位</div>
      <div style="color:#129c7a">|</div> -->
      <!-- <div :class="[zbdw==3 ? 'activeClass' : 'ycactiveClass']" @click="zbdwclick(3)">partner</div> -->
      <!-- <div style="color:#129c7a">|</div> -->
      <!-- <div :class="[zbdw==4 ? 'activeClass' : 'ycactiveClass']" @click="zbdwclick(4)">Green Partner</div> -->
      <!-- <div style="color:#129c7a">|</div> -->
      <!-- <div :class="[zbdw==5 ? 'activeClass' : 'ycactiveClass']" @click="zbdwclick(5)">Some exhibitors</div> -->
      <!-- <div style="color:#129c7a">|</div> -->
      <!-- <div :class="[zbdw==6 ? 'activeClass' : 'ycactiveClass']" @click="zbdwclick(6)">Media</div> -->

    <!-- </div> -->

    <div class="exhibitors">
      <div class="exhibitors-cont">
        <!-- <div v-if=" mbactive==='1'">
          <el-row :gutter="20">
            <el-col style="display: flex;justify-content: center;align-items: center" v-for="(item,index) in titleImgData" :key="index" :span="4">
              <div style="width:200px;height:100px;display:flex;justify-content:center;align-items: center;">
                <img @click="jumpurl(item.url)" style="max-width:90%;max-height:90%;" :src="item.img" alt="">
              </div>
            </el-col>
          </el-row>
        </div>
        <div v-if=" mbactive==='2'">
          <el-row :gutter="20">
            <el-col style="display: flex;justify-content: center;align-items: center" v-for="(item,index) in exhibitorsData" :key="index" :span="4">
              <div style="width:200px;height:100px;display:flex;justify-content:center;align-items: center;">
                <img  @click="jumpurl(item.url)" style="max-width:90%;max-height:90%;" :src="item.img" alt="">
              </div>
            </el-col>
          </el-row>
        </div> -->
        <!-- <div class="jiantou" v-if=" mbactive==='1'" @click="handleChangezk">
          <img src="../assets/home/jiantou1.png" alt="">
        </div>
        <div class="jiantou" v-if=" mbactive==='2'" @click="handleChangesq">
          <img src="../assets/home/jiantou2.png" alt="">
        </div> -->

      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      zxzs: '500+',
      tygz: '30000',
      zgmj: '30000',
      ls: '40',
      // 目标日期，可以是任何有效的日期格式
      targetDate: new Date('2026-06-02 00:00:00').getTime(),
      countdowntime: '',
      sfmtime: '',
      bannerimg: [
        { img: '../assets/home/图3.jpg' },
        { img: 'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg' }
      ],
      bannerdate: '2025年04月10日',
      banneryear: '第20届（2021年）',
      value1: '',
      value2: '',
      value3: '',
      zbdw: '3',
      exhibitorsData: [],
      titleImgData: [],
      exhibitorsSwiper: [],
      mbactive: '1'
    }
  },
  mounted () {
    this.countdown()
    this.zbdwclick(3)
  },
  methods: {
    jumpurl (url) {
      window.location.href = url
    },
    showMaintainAlert () {
      this.$alert('This feature is under maintenance. Please stay tuned!', 'Notice', {
        confirmButtonText: 'OK',
        type: 'info',
        center: true
      })
    },
    handleChangezk () {
      this.mbactive = '2'
    },
    handleChangesq () {
      this.mbactive = '1'
    },
    getExhibitorsData () {
      this.exhibitorsSwiper = []
      let dataList = this.exhibitorsData // 获取到数据
      for (let i = 0; i < dataList.length; i += 5) {
        this.exhibitorsSwiper.push(dataList.slice(i, i + 5))
      }
    },
    zbdwclick (index) {
      this.zbdw = index
      this.mbactive = '1'
      if (index === 1) {
        // this.textcolor1 = '#0e9c77'
        this.exhibitorsData = [{
          url: 'http://www.caepi.org.cn/',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20220831090343.png',
          name: '中国环境保护产业协会'
        }]
        this.titleImgData = this.exhibitorsData.slice(0, 6)
      } else if (index === 3) {
        this.exhibitorsData = [{
          url: 'http://www.tdbmofcom.org.cn/',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230907154501.jpg',
          name: '商务部外贸发展事务局'
        }, {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230907154818.jpg',
          name: '香港特别行政区政府环境保护署'
        },
        {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230907154818(1).jpg',
          name: '澳门特别行政区政府环境保护局'
        }, {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230907154818(2).jpg',
          name: '韩国环境部'
        },
        {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230907155528(5).jpg',
          name: '大韩贸易投资振兴公社北京办事处'
        },
        {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230907155528.jpg',
          name: '挪威创新署'
        },
        {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230907155528(1).jpg',
          name: '挪威驻华大使馆商务处'
        },
        {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230907155528(3).jpg',
          name: '意大利对外贸易委员会北京办事处'
        },
        {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230907155528(4).jpg',
          name: '英国驻华大使馆商业贸易部'
        },
        {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230907155529(1).jpg',
          name: '加拿大驻华大使馆商贸处'
        },
        {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230907160113.jpg',
          name: '美国驻华大使馆商贸处'
        },

        {
          url: 'http://www.craes.cn/',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230907161033.jpg',
          name: '中国环境科学研究院'
        },
        {
          url: 'http://www.cnemc.cn/',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230907161234.jpg',
          name: '中国环境监测总站'
        },
        {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230907161359.jpg',
          name: '生态环境部环境发展中心'
        },
        {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230907172517.jpg',
          name: '生态环境部环境与经济政策研究中心'
        },
        {
          url: 'https://www.cenews.com.cn/',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230907172546.jpg',
          name: '中国环境报社'
        },
        {
          url: 'http://www.fecomee.org.cn/',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230907172615.jpg',
          name: '对外合作与交流中心'
        },
        {
          url: 'https://www.nies.org/',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230907172648.jpg',
          name: '生态环境部南京环境科学研究所'
        },
        {
          url: 'http://www.scies.org/',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230907172718.jpg',
          name: '生态环境部华南环境科学研究所'
        },
        {
          url: 'http://www.caep.org.cn/',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230907172751.jpg',
          name: '环境规划院'
        },
        {
          url: 'http://www.china-eia.com/',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230907172902.jpg',
          name: '环境工程评估中心'
        },

        {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230907173054.jpg',
          name: '生态环境部卫星环境应用中心'
        },

        {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230907173134.jpg',
          name: '固管中心'
        },

        {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230912145142.jpg',
          name: '国家海洋环境监测中心'
        },

        {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230907173200.jpg',
          name: '土壤中心'
        },

        {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230907173232.jpg',
          name: '生态环境部宣传教育中心'
        },

        {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230907173303.jpg',
          name: '中环环保基金会'
        },

        {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230907173328.jpg',
          name: '中国生态文明研究与促进会'
        },

        {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230912145142(1).jpg',
          name: '中国核安全与环境'
        },

        {
          url: 'http://www.cpcia.org.cn/',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230912110358.jpg',
          name: '中国石油和化学工业联合会'
        },

        {
          url: 'http://www.cbmf.org/',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230912110439.jpg',
          name: '中国建筑材料联合会'
        },
        {
          url: 'http://www.chinaisa.org.cn/',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230912113221.jpg',
          name: '中国钢铁工业协会'
        },
        {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230912111830.jpg',
          name: '中国电力企业联合会'
        },
        {
          url: 'http://www.chinamining.org.cn/',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230912112450.jpg',
          name: '中国矿业联合会'
        },
        {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230912112211.jpg',
          name: '中国核工业勘察设计协会'
        },
        {
          url: 'https://www.chinca.org/',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230912111611.jpg',
          name: '中国对外承包工程商会'
        },
        {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230912111725.jpg',
          name: '中国产业海外发展协会'
        },
        {
          url: 'http://www.zxsx.org/',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230912112743.jpg',
          name: '中国中小商业企业协会'
        },
        {
          url: 'http://www.crra.org.cn/',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230912112532.jpg',
          name: '中国再生资源回收利用协会'
        },
        {
          url: 'http://www.foundry.org.cn/',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230912112807.jpg',
          name: '中国铸造协会'
        },
        {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230912110243.jpg',
          name: '中国皮革协会'
        },
        {
          url: 'http://www.cnljxh.com/',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230912112636.jpg',
          name: '中国炼焦行业协会'
        },
        {
          url: 'http://org.caaa.cn/',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230912112126.jpg',
          name: '中国畜牧业协会'
        },
        {
          url: 'http://www.csea1991.org/',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230912111500.jpg',
          name: '中国表面工程协会'
        },
        {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230912111756.jpg',
          name: '中国硅酸盐学会'
        },
        {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230912110052.jpg',
          name: '中国农药工业协会'
        },
        {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230912112243.jpg',
          name: '中国环保机械行业协会'
        },
        {
          url: 'http://www.cciepa.org.cn/',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230912113122.jpg',
          name: '中国化工环保协会'
        },
        {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230912155638.jpg',
          name: '中国工业节能与清洁生产协会'
        },
        {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230912112924.jpg',
          name: '中国木材保护工业协会'
        },
        {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230912111427.jpg',
          name: '中国报关协会'
        },
        {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230912112846.jpg',
          name: '中国电子节能技术协会'
        },
        {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230912113030.jpg',
          name: '中国健康管理协会'
        },
        {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230912111245.jpg',
          name: '中国设备监理协会'
        },
        {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230912112709.jpg',
          name: '中国建设教育协会'
        },
        {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230912105947.jpg',
          name: '韩国环境产业协会'
        },
        {
          url: '',
          img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230912105908.jpg',
          name: '挪威能源与环境协会'
        }
        ]
        this.titleImgData = this.exhibitorsData.slice(0, 6)
      } else if (index === 4) {
        this.exhibitorsData = [
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20191121103917.jpg',
            name: '万华'
          }
        ]
        this.titleImgData = this.exhibitorsData.slice(0, 6)
      } else if (index === 5) {
        this.exhibitorsData = [
          {
            url: 'http://www.ccepc.com/',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230324195052.png',
            name: '中冶南方都市环保'
          }, {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20240428092715.jpg',
            name: '中铁建'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20240428092218.png',
            name: '中化环境'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20240428092051.jpg',
            name: '葛洲坝'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20190916091739.jpg',
            name: '天虹'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20211220181927.png',
            name: '北排'
          },
          {
            url: 'http://www.lonjing.com/',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20201216143608.png',
            name: '龙净'
          },
          {
            url: 'http://www.yunzhou-tech.com/',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230324195052(1).png',
            name: '珠海云舟'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20201216143906(2).jpg',
            name: '盈峰'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20201216143906(1).jpg',
            name: '景津'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20201216143608(2).jpg',
            name: '京城'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20190916091738(2).png',
            name: '雪迪龙'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20190916091528.png',
            name: '安徽皖仪'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20190916091618.png',
            name: '河北先河'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20190916091739.png',
            name: '崂应'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20190916091419(1).png',
            name: '聚光科技'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20190916091627.png',
            name: '新大禹'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20211220181720.png',
            name: '碧兴物联'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20190916091419.png',
            name: '国环莱茵'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20190916091419(2).png',
            name: '同兴'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20190916091738(4).png',
            name: '岛津'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20190916091739(2).png',
            name: '西克曼哈克'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20190916091739(3).png',
            name: '西门子'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20201216143608(1).png',
            name: '南华'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20201216144418.jpg',
            name: '高能'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20201216143608.jpg',
            name: '三峰'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230207175112.png',
            name: '海康威视'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20201216143906.jpg',
            name: '复洁'
          }
        ]
        this.titleImgData = this.exhibitorsData.slice(0, 6)
      } else if (index === 6) {
        this.exhibitorsData = [
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230925092343.gif',
            name: '人民日报'
          }, {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230925092343.png',
            name: '人民网'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20221217195730.png',
            name: '新华网能源频道'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230925094126.jpg',
            name: '央视'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230925094126(1).jpg',
            name: '央广'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230925094316.jpg',
            name: '光明日报'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230925092343(1).png',
            name: '经济日报'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230925092343.jpeg',
            name: '科技日报'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230925092343(1).jpg',
            name: '中新社'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230925092343.jpg',
            name: '中国青年报'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230925112050.jpg',
            name: '法制日报'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20221217195553.png',
            name: '中国环境报'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230925140921.jpg',
            name: '北京电视台'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230925112948.jpg',
            name: '中国改革报'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230925112051.jpg',
            name: '中国工业报'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230925112635.gif',
            name: '新京报'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230925112332.jpg',
            name: '澎湃新闻'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230925135841.jpg',
            name: '每日经济新闻'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230925113311.jpg',
            name: '经济观察报'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230925140948.jpg',
            name: '环境保护杂志'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230925140140.jpeg',
            name: '新浪财经'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230925113505.jpg',
            name: '凤凰网'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230925113736.jpg',
            name: '腾讯网'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230925140336.jpg',
            name: '搜狐视频'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230925140405.jpeg',
            name: '腾讯视频'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230203193631.jpg',
            name: '中国环保产业'
          },
          {
            url: '',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230207175750.jpg',
            name: '青山'
          },
          {
            url: 'http://www.hbzhan.com/',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20221226100248.png',
            name: '环保在线'
          },
          {
            url: 'https://huanbao.bjx.com.cn/',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230130161215.png',
            name: '北极星'
          },
          {
            url: 'www.epzhw.com',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20221226100547.png',
            name: '中环网'
          },
          {
            url: 'http://www.gepresearch.com/',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20221226100312.jpg',
            name: '全球环保研究网'
          },
          {
            url: 'https://www.instrument.com.cn/',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20221226100331.jpg',
            name: '仪器信息网'
          },
          {
            url: 'www.51hbjob.com',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20221226100356.jpg',
            name: '必高'
          },
          {
            url: 'http://www.chem17.com',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20221226100421.png',
            name: '化工仪器网'
          },
          {
            url: 'www.chinawfjsw.com',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20221226100730.jpg',
            name: '危废技术网'
          },
          {
            url: 'www.chinagygfw.com',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20221226100749.png',
            name: '工业固废网'
          },
          {
            url: 'https://www.eiacloud.com/',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20230203192827.png',
            name: '尚云互联'
          },
          {
            url: 'www.bf35.com',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20221226100711.png',
            name: '泵阀商务网'
          },
          {
            url: 'www.ppzhan.com/',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20221226100901.jpg',
            name: '包装印刷网'
          },
          {
            url: 'http://www.cin.cn/',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20221226101026.png',
            name: '水工业'
          },
          {
            url: 'http://www.yqzl.ibicn.com/',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20221226101129.jpg',
            name: '除尘'
          },
          {
            url: 'http://www.hqhb.org.cn/',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20221226101152.png',
            name: '全球生态环保杂志'
          },
          {
            url: 'https://yjjn.cbpt.cnki.net/',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20221226101058.png',
            name: '有色冶金节能'
          },
          {
            url: 'http://www.asia-ep.net/',
            img: 'https://www.ciepec-online.com/u/cms/www/xwy-images/20221226101003.jpg',
            name: '亚洲环保杂志'
          }
        ]
        this.titleImgData = this.exhibitorsData.slice(0, 6)
      }

      // this.getExhibitorsData()
    },
    countdown () {
      const now = new Date().getTime()
      const distance = this.targetDate - now

      if (distance < 0) {
        return '倒计时已结束'
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24))
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = Math.floor((distance % (1000 * 60)) / 1000)
      const that = this
      this.countdowntime = `${days}`
      this.sfmtime = `${hours}时 ${minutes}分 ${seconds} 秒`
      // 一秒后递归
      setTimeout(function () {
        that.countdown()
      }, 1000)
    },
    zgpmt (index1, index2, title) {
      // this.$router.push({path: '/', query: {page: '1', pageNum: '5'}})
      this.value1 = index1
      this.value2 = index2
      this.value3 = title
      this.$emit('childFn', this.value1, this.value2, this.value3)
    },
    zwyd (index1) {
      this.value1 = index1
      this.$emit('childFn', this.value1, '', '')
    }
  }

}
</script>
<style scoped>
.activeClass {
  color: #0e9c77;
}
.ycactiveClass {
  color: #000;
}
.exhibitors {
  /* height: 200px !important; */
  /* padding: 1.44rem 0 0.75rem 0; */
}
.flex-center-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.exhibitors-cont {
  width: 80%;

  margin: 0 auto;
}

.el-carousel__container {
  height: 200px !important;
}

::v-deep .el-carousel__arrow {
  background-color: rgba(255, 255, 255, 1);
  color: rgba(46, 53, 143, 1);
}
.exhibitors-item-section {
  width: 30%;
  height: 150px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.exhibitors-item-section:nth-child(2n) {
  margin: 0 15px;
}
.exhibitors-item-img {
  width: 160px;
  height: 90px;
  margin: 0 20px;
}

.exhibitors-item-img1 {
  width: 160px;
  height: 90px;
  margin: 0 20px;
}

@font-face {
  font-family: LetsgoDigitalRegular;
  src: url('../font/LetsgoDigitalRegular.ttf');
}

body {
  padding: 0;
  margin: 0 !important;
}
.index {
  width: 100%;
  background-image: url('../assets/home/caodi.png'); /* 设置图片路径 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center bottom; /* 设置背景图片居中底部 */
  background-size: 100% auto; /* 设置背景图片宽度100%，高度自动 */
}
.bigbgi {
  background-image: url('../assets/home/Header1.png'); /* 设置图片路径 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center; /* 背景图片居中 */
  background-size: cover;
  height: 740px; /* 元素高度 */
  width: 100%;
  margin-bottom: 20px;
}
.midbgi {
  background-image: url('../assets/home/renwu.png'); /* 设置图片路径 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center; /* 背景图片居中 */
  height: 700px; /* 元素高度 */
  width: 100%;
}
.fourliebiao {
  width: 80%;
  margin: 0 auto;
}
.shuju {
  display: flex;
  justify-content: space-around;
  height: 575px;
}
.jiantou {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  padding-bottom: 10px;
}
.changguan {
  flex: 1.5;
  margin-top: 100px;
}
.djs {
  flex: 1;
}
.zgdetail {
  margin-top: 50px;
}
.borderstyle {
  /* width: 200px; */
  height: 200px;
  background: #ffffff;
  box-shadow: 1.32px 23.62px 63.84px 0px rgba(41, 41, 41, 0.04);
  border-radius: 8.83px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center; /* 水平居中 */
}
.wzintro {
  font-family: SourceHanSansSC-Bold;
  font-size: 14px;
  color: #000000;
  letter-spacing: 0.14px;
  text-align: center;
  line-height: 28px;
  font-weight: 700;
  margin-top: 10px;
}
.djs {
  background-image: url('../assets/home/daojishibg.png'); /* 设置图片路径 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-size: cover;
  background-position: center; /* 背景图片居中 */
  height: 550px; /* 元素高度 */
  display: flex;
  align-items: center;
  justify-content: center;
}

.textcolor {
  background: linear-gradient(to bottom, #ffffff 50%, #0081cc);
  -webkit-background-clip: text;
  color: transparent; /* 设置文字颜色透明，以显示背景渐变色 */
  display: flex;
  align-items: center;
  justify-content: center;
}
.gnbox {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  height: 200px;
  width: 100%;
  overflow-x: auto;
  padding: 0 20px;
}
.jchg {
  height: 780px;
}
.banner {
  flex: 1.5;
  margin-right: 40px;
}
.newslist {
  flex: 1;
}
a {
  text-decoration: none;
}
.zbdw {
  cursor: pointer;
  margin: 0 auto;
  padding: 20px 0;
  width: 70%;
  display: flex;
  justify-content: space-between;
  font-size: 20px;
  color: #0e9c77;
  letter-spacing: 0;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/indexeng.vue